
const defaultState = {
    app: {
        user: null,
        teams: [],
        serviveEntry: null,
        apiDocView: {
            apidoc: null,
        },
        apiView: {
            api: null,
        }
    }
};

export default defaultState;
